module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA/ElEQVQ4T83Sv0oDQRgE8Jk9G1sllRY5LbQwnn+CDyW66UREMFUKG8n5Fj6CjxBUPBW0kU2hlSRWooLuyKUQwdyxh43b7jc/vh2W9RW7Q6ENYBLVzquINuPEvkjYI6KLKnnhc41EJwdkPJr31+l5FWC+Yde9wdkvIE62N7zR9DjMeA5cdtzL70oAewdgpmCbR5eli6VA6DMKN/gzECe2D2C2AHpwWVov72CptawJTo0D+KGhu+le/fMOQkucW91qypve90dShAWJm4CiEEREjZ7PI0DQAcF9AkcSnkIAkG9G7ycjAIBE7PYv08Og8I+hHLgFeOqybqtqOJ//Au6fobEt3B+pAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fkmsg.png
// module id = 6Px8
// module chunks = 167